document.addEventListener('DOMContentLoaded', () => {
    const animatedNodes = document.querySelectorAll('.animated-number-block');
    // Track which nodes have been animated
    const animatedNodeTracker = new Set();

    const isInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    const animateNumber = (element, targetNumber, suffix) => {
        const duration = 2000; // Animation duration in ms
        let startTimestamp = null;

        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            element.innerText = Math.floor(progress * targetNumber).toLocaleString() + suffix;

            if (progress < 1) {
                window.requestAnimationFrame(step);
            } else {
                element.innerText = targetNumber.toLocaleString() + suffix; // Ensure the final number is set correctly
            }
        };

        window.requestAnimationFrame(step);
    };

    const applyAnimationIfNeeded = (node) => {
        // Skip if this node has already been animated
        if (animatedNodeTracker.has(node)) {
            return;
        }
        
        if (isInViewport(node)) {
            const animatedNumberElement = node.querySelector('.animated-number');
            const dataNumber = animatedNumberElement.getAttribute('data-number');
            
            // Extract numeric part and suffix
            const numericPart = parseInt(dataNumber.replace(/[^0-9]/g, '')); // Only keep digits
            const suffix = dataNumber.replace(/[0-9,]/g, ''); // Only keep non-digit characters

            animateNumber(animatedNumberElement, numericPart, suffix);
            
            // Mark this node as animated
            animatedNodeTracker.add(node);
            
            // Only remove event listeners if all nodes have been animated
            if (animatedNodeTracker.size === animatedNodes.length) {
                window.removeEventListener('scroll', handleScroll);
                window.removeEventListener('resize', handleScroll);
            }
        }
    };

    const handleScroll = () => {
        animatedNodes.forEach((node) => {
            applyAnimationIfNeeded(node);
        });
    };

    // Initial check on page load
    handleScroll();

    // Check again on scroll or resize
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
});